export function setSessionItem(key, value) {
  sessionStorage.setItem(key, value);
  window.dispatchEvent(
    new CustomEvent('session-storage', {detail: {key, value}}),
  );
}
